import request from '@/utils/request'

export const uploadFile = (file) => {
  const formData = new FormData()
  formData.append('fileName', file)
  console.log(formData)
  return request({
    url: '/hz-file/file/fileUpLoad',
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}
// 通过url获取微信签名
export const getWechatSignature = () => {
  const url = location.origin + location.pathname
  return request({
    url: '/api/transport/wechat/getSignature',
    method: 'POST',
    data: {
      url
    }
  })
}
